import { render, staticRenderFns } from "./LiquorLicense.vue?vue&type=template&id=2b04fc73"
import script from "./LiquorLicense.vue?vue&type=script&lang=ts"
export * from "./LiquorLicense.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports